import { render, staticRenderFns } from "./SettingsNav.vue?vue&type=template&id=145fb97b&"
import script from "./SettingsNav.vue?vue&type=script&lang=js&"
export * from "./SettingsNav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports